import type { MaybeRefOrGetter } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IGetManagersResponse, IManagersList } from '../types';
import { AFFILIATE_MANAGERS_API_URL, AFFILIATE_MANAGERS_QUERY_KEY, AFFILIATES_APPROVED_PERMISSIONS } from '../constants';

export default function useAffiliateManagersQuery(enabled: MaybeRefOrGetter<boolean | undefined> = false): IContextQueryResult<IGetManagersResponse, Error, IManagersList> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IGetManagersResponse, Error, IManagersList>({
    queryKey: [AFFILIATE_MANAGERS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IGetManagersResponse>(AFFILIATE_MANAGERS_API_URL, {
      signal,
      permission: AFFILIATES_APPROVED_PERMISSIONS.CHANGE_MANAGER_FOR_AFFILIATES,
    }),
    select: (data) => (data.list),
    enabled,
  });
}
